import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, RequestMethod } from '@angular/http';
import 'rxjs/add/operator/map';

import { UserModel } from '../model/user/user';
import { Cookie } from 'ng2-cookies';
import { Router } from '@angular/router';
import { JwtHelper } from 'angular2-jwt';
import { OAuthService } from 'angular-oauth2-oidc';
import { PasswordDto } from '../model/user/password-dto';
import { environment } from 'environments/environment';
import { JwtService } from '../../jwt/jwt.service';

@Injectable()
export class UserService {
  private token: string;
  private expires_in: number;
  private intervalId: any = null;
  private intervalLength = 0.1;
  private clientId = environment.clientId;
  private clientSecret = environment.clientSecret;
  private scope = 'read write';
  private responseType = 'token';

  constructor(private http: Http, private router: Router, private oauthService: OAuthService, private jwtService: JwtService) {
      this.oauthService.loginUrl = environment.securityUrl + '/oauth/authorize';
      this.oauthService.redirectUri = environment.redirectUrl;
      this.oauthService.clientId = environment.clientId;
      this.oauthService.scope = 'read write';
      this.oauthService.setStorage(sessionStorage);
      this.oauthService.tryLogin({});

   }


  /**
   * 로그인
   */
  obtainAccessToken(username: string, password: string) {

    const params = new FormData();
    params.append('username', username);
    params.append('password', password);
    params.append('grant_type', 'password');
    // params.append('client_id', environment.clientId);

    const headers = new Headers({'Authorization': 'Basic '
      + btoa(environment.clientId + ':' + environment.clientSecret)});
    // console.log('Basic ' + btoa(environment.clientId + ':' + environment.clientSecret));
    this.http.post(environment.securityUrl + '/oauth/token', params, { headers : headers} )
    .subscribe(
      response => {
        sessionStorage.setItem('access_token', response.json().access_token);
          this.router.navigate(['/']);
      },
      error => {
        alert(error.json().error_description);
      },
    );
  }

  /**
   * 회원 정보 수정
   */
  modifyUser(name: String, profileUrl: String) {
    return this.http.put(environment.userUrl + '/users/' + this.jwtService.getUserIdFromSession(), {
      'name' : name,
      'profileUrl' : profileUrl
    }, {
      headers : new Headers({'authorization' : 'bearer ' + sessionStorage.getItem('access_token')})
    });
  }

  /**
  * 회원 상세 정보
  */
  getUser() {
      return this.http.get(environment.userUrl + '/users/' + this.jwtService.getUserIdFromSession(), {
           headers : new Headers({'authorization' : 'bearer ' + sessionStorage.getItem('access_token')})
      });
  }


  /**
   * 쿠키에 토큰 저장
   * @param token
   */
  saveToken(token) {

    const expiresDate = (token.expires_in / 24 / 60 / 60);

    Cookie.set('access_token', token.access_token, expiresDate);
    alert('로그인');
    this.router.navigate(['/']);
  }

  saveUsername(username) {
    Cookie.set('username', username, 7);
  }

  /**
   * access 토큰 존재여부 확인
   */
  checkCredentials() {
    if (!Cookie.check('access_token')) {
        this.router.navigate(['/login']);
    }
  }


  /**
   * 로그아웃
   */
  logout() {
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('expiresAt');
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('profileUrl');
    alert('로그아웃');
    this.router.navigate(['']);
  }

  private parse(str) {
        if (typeof str !== 'string') {
            return {};
        }

        str = str.trim().replace(/^(\?|#|&)/, '');

        if (!str) {
            return {};
        }

        return str.split('&').reduce(function (ret, param) {
            const parts = param.replace(/\+/g, ' ').split('=');
            let key = parts.shift();
            let val = parts.length > 0 ? parts.join('=') : undefined;

            key = decodeURIComponent(key);

            val = val === undefined ? null : decodeURIComponent(val);

            if (!ret.hasOwnProperty(key)) {
                ret[key] = val;
            } else if (Array.isArray(ret[key])) {
                ret[key].push(val);
            } else {
                ret[key] = [ret[key], val];
            }

            return ret;
        }, {});
    };

  obtainAccessTokenImplictFlow() {
    this.oauthService.initImplicitFlow();
  }



  /**
   * 아이디 중복 체크
   */
  isDuplicate(username, email) {
    return this.http.get(environment.userUrl + '/users/isDuplicate?username=' + username + '&email=' + email);
  }

  /**
  * 헤더 설정
  */
  getHeadersFromSession() {
    const headers = new Headers({'authorization' : 'bearer ' + sessionStorage.getItem('access_token')});
    return headers;
  }

  getUsername() {
    return sessionStorage.getItem('username');
  }

  getProfileUrl() {
    return sessionStorage.getItem('profileUrl');
  }

  /**
   * 쿠키에 사용자 정보 저장
   */
  setUserInfo() {

    this.http.get(environment.userUrl + '/user/me', {headers : this.getHeadersFromSession()}).subscribe(response => {

      const name = response.json().details.decodedDetails.name;
      let profileUrl = response.json().details.decodedDetails.profileUrl;

      if (profileUrl == null || profileUrl.length < 1 ) {
        profileUrl = 'image/img.jpg';
      }

      sessionStorage.setItem('username', name);
      sessionStorage.setItem('profileUrl', profileUrl);
    });
  }

  /**
   * 패스워드 변경
   */
  updatePassword(oldPassword, newPassword) {
    const passwordDto = new PasswordDto();
    passwordDto.newPassword = newPassword;
    passwordDto.oldPassword = oldPassword;

    return this.http.put(environment.userUrl + '/user/password', passwordDto , {headers : this.getHeadersFromSession()});
  }

  /**
   * 서버에 로그아웃 요청
   */
  logoutRequest() {
    return this.http.get(environment.securityUrl + '/logout');
  }

  /**
   * 세션 스토리지의 토큰 값 가져오기
   */
  getToken() {
    return sessionStorage.getItem('access_token');
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/common/api/user.service.ts